import React from 'react';
import { SmallText } from 'ds/components/typography';
import ExpandArrow from 'assets/svg/chevron-down.svg';
import { SectionTitle, SectionType } from 'components/widget/common/styled';
import { useLocale } from 'locale';
import { InsightType } from 'utils/entities';
import { PricesSectionType } from 'store/state/selectors/insights/prices';
import HistoryIcon from 'assets/svg/sale-history.svg';
import ComparableListingsIcon from 'assets/svg/active-listings.svg';

interface TitleProps {
  toggleActiveSection: () => void;
  isActive: boolean;
  sectionId: PricesSectionType;
  isOpen?: boolean;
}

const sectionIdToIcon: Record<PricesSectionType, JSX.Element> = {
  [PricesSectionType.LocalHistory]: <HistoryIcon />,
  [PricesSectionType.ComparableListings]: <ComparableListingsIcon />,
  [PricesSectionType.Listing]: null,
};

export const Title: React.FunctionComponent<TitleProps> = ({ isActive, isOpen, toggleActiveSection, sectionId }) => {

  const { t } = useLocale();

  const handleClick = () => {
    if (isOpen) {
      return;
    }
    toggleActiveSection();
  };

  return (
    <SectionTitle onClick={handleClick} type={InsightType.Prices} isActive={isActive}>
      <SectionType type={InsightType.Prices}>
          {sectionIdToIcon[sectionId]}
          <SmallText weight="medium" caps>{t('widget.prices.accordionTitle', { sectionId })}</SmallText>
      </SectionType>
      <ExpandArrow width={22} height={22} />
    </SectionTitle>
  );
};
